import { Typography } from "antd";
const { Text } = Typography;

export const dataSourceMock = [
    {
        id: 1,
        key: "1",
        name1: "กองสื่อสารองค์กร",
        name2: "",
        chanal: "Website",
        t11: "เว็บไซต์ กนอ.",
        t12: "www.ieat.go.th",
        t2: "2566",
        t3: "2",
        t4: "ประเทศตะวันออก (ทวีปเอเชีย ทวีปแอฟริกา และตะวันออกกลาง)",
        t5: "กลุ่มลูกค้ามากกว่า 10 ปี",
        t6: "ด้านผลิตภัณฑ์และบริการ",
        t7: "ความต้องการของลูกค้า (หมายถึง สิ่งที่เป็นพื้นฐานที่ลูกค้าต้องการได้รับ เมื่อมาใช้ผลิตภัณฑ์และบริการ หากลูกค้าไม่ได้รับอาจจะเกิดความไม่พึงพอใจได้ แต่ถ้ามี ลูกค้าคิดว่าเป็นเรื่องปกติที่จะต้องได้รับอยู่แล้ว)",
        question1: 1,
        question2: "-",
        question3: 1,
        question4: 2,
        question5: "-",
        question6: "-",
        question7: "-",
        filename: "Test.pdf",
    },
    {
        id: 2,
        key: "2",
        name1: "กองสื่อสารองค์กร",
        name2: "นิคมอุตสาหกรรมลาดกระบัง",
        chanal: "Website",
        t11: "เว็บไซต์ กนอ.",
        t12: "www.ieat.go.th",
        t2: "2566",
        t3: "2",
        t4: "ประเทศตะวันออก (ทวีปเอเชีย ทวีปแอฟริกา และตะวันออกกลาง)",
        t5: "กลุ่มลูกค้ามากกว่า 10 ปี",
        t6: "ด้านผลิตภัณฑ์และบริการ",
        t7: "ความต้องการของลูกค้า (หมายถึง สิ่งที่เป็นพื้นฐานที่ลูกค้าต้องการได้รับ เมื่อมาใช้ผลิตภัณฑ์และบริการ หากลูกค้าไม่ได้รับอาจจะเกิดความไม่พึงพอใจได้ แต่ถ้ามี ลูกค้าคิดว่าเป็นเรื่องปกติที่จะต้องได้รับอยู่แล้ว)",
        question1: 1,
        question2: "-",
        question3: 1,
        question4: 2,
        question5: "-",
        question6: "-",
        question7: "-",
        filename: "Test.pdf",
    },
];

export const quarter = [
    { name: "เลือกทั้งหมด", value: "" },
    { name: "1 (ตุลาคม-ธันวาคม)", value: "1" },
    { name: "2 (มกราคม-มีนาคม)", value: "2" },
    { name: "3 (เมษายน-มิถุนายน)", value: "3" },
    { name: "4 (กรกฎาคม-กันยายน)", value: "4" },
];

export const YearOf = [
    { name: "เลือกทั้งหมด", value: "" },
    { name: "2567", value: "2567" },
    { name: "2566", value: "2566" },
    { name: "2565", value: "2565" },
    { name: "2564", value: "2564" },
    { name: "2563", value: "2563" },
];
export const YearOfBC = [
    { name: "เลือกทั้งหมด", value: "" },
    { name: "2567", value: "2024" },
    { name: "2566", value: "2023" },
    { name: "2565", value: "2022" },
    { name: "2564", value: "2021" },
    { name: "2563", value: "2020" },
];

export const Years = [
    { name: "2567", value: "2567" },
    { name: "2566", value: "2566" },
    { name: "2565", value: "2565" },
    { name: "2564", value: "2564" },
    { name: "2563", value: "2563" },
];

export const agency_All = [
    { name: "กองสื่อสารองค์กร", value: "กองสื่อสารองค์กร" },
    { name: "กองลูกค้าสัมพันธ์", value: "กองลูกค้าสัมพันธ์" },
    { name: "กองการตลาด", value: "กองการตลาด" },
    { name: "กองอาคารและสถานที่", value: "กองอาคารและสถานที่" },
    { name: "ฝ่ายบริการผู้ประกอบการ", value: "ฝ่ายบริการผู้ประกอบการ" },
    { name: "สำนักงานนิคมอุตสหกรรม", value: "สำนักงานนิคมอุตสหกรรม" },
];

export const channelList = [
    "Website",
    "Facebook",
    "Twitter",
    "Email",
    "Office phone",
    "LinkIn",
    "Wechat",
    "Weibo",
    "One Stop Service Center",
    "Application I-EA-T Touch",
    "I-EA-T e-PP",
    "Line Official",
    "Group Line",
    "Mail/Fax",
    "TSC",
    "Publicity Signs/Brochures"
];

export const masterDataFuture = ["current_status","current_status_v2","future_industry_type", "company_type", "industry_type"
    ,"region_type", "area_type","future_area_type","future_estate_type", "known_channel", "region_group", "purpose_contact"];
export const vocDataFuture = [
    "product_requirement",
    "customer_support",
    "business_require",
    "customer_expect",
    "other_product_expect",
    "other_support_expect",
    "other_business_expect",
    "future_product_require",
    "future_customer_support",
    "future_business_require",
    "future_customer_expect",
    "future_other_product_expect",
    "future_other_support_expect",
    "future_other_business_expect",
];

export const questionnaire = [
    {
        name: "กองสื่อสารองค์กร",
        value: [
            "เว็บไซต์ กนอ. www.ieat.go.th",
            "Facebook: Industrial Estate Authority of Thailand IEAT",
            "Twitter : Industrial Estate Authority of Thailand (กนอ.)",
            "Email การรับแจ้งเหตุ/การร้องเรียน : complaint@ieat.mail.go.th",
            "โทรศัพท์สำนักงาน",
        ],
        chanal: ["Website", "Facebook", "Twitter", "Email", "Office phone"],
    },
    { name: "กองลูกค้าสัมพันธ์", value: ["Email การรับแจ้งเหตุ/การร้องเรียน : complaint@ieat.mail.go.th ยังไม่ได้ทำแบบสอบถาม"], chanal: ["Email"] },
    {
        name: "กองการตลาด",
        value: [
            "LinkedIn : Industrial Estate Authority of Thailand (I-EA-T) ยังไม่ได้ทำแบบสอบถาม",
            "Wechat",
            "Weibo : IEAT",
            "Email บริการให้ข้อมูล บริการให้คำปรึกษา นักลงทุน : investment.1@ieat.mail.go.th",
        ],
        chanal: ["LinkIn", "Wechat", "Weibo", "Email"],
    },
    { name: "กองอาคารและสถานที่", value: ["โทรศัพท์สำนักงาน"], chanal: ["Office phone"] },
    {
        name: "ฝ่ายบริการผู้ประกอบการ",
        value: [
            "ศูนย์บริการเบ็ดเสร็จครบวงจร (Total Solution Center : TSC) ของสำนักงานใหญ่",
            "แอปพลิเคชัน I-EA-T Touch",
            "ระบบ I-EA-T e-PP (บริการด้านอนุมัติ/อนุญาต)",
            "Line Official",
        ],
        chanal: ["One Stop Service Center", "Application I-EA-T Touch", "I-EA-T e-PP", "Line Official"],
    },
    { name: "สำนักงานนิคมอุตสหกรรม", value: ["Line กลุ่มผู้ประกอบการ", "จดหมาย/โทรสาร"], chanal: ["Group Line", "Mail/Fax"] },
];

export const detailAgency = (text) => {
    switch (text) {
        case "Website":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 24 ชั่วโมง (ในวันและเวลาทำการ)
                    <br />
                    2) ระบบสามารถให้บริการข้อมูลแก่ลูกค้าได้ทันทีที่ลูกค้าต้องการ (24 ชั่วโมง)
                    <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;

        case "Facebook":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard)
                    <br />
                    1) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 1 ชั่วโมง <br />
                    2)ระบบสามารถให้บริการข้อมูลแก่ลูกค้าได้ทันทีที่ลูกค้าต้องการ (24 ชั่วโมง) <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;

        case "Twitter":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard)
                    <br />
                    1) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 1 ชั่วโมง
                    <br />
                    2) ระบบสามารถให้บริการข้อมูลแก่ลูกค้าได้ทันทีที่ลูกค้าต้องการ (24 ชั่วโมง)
                    <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Email":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) ระบบนำส่งข้อความอัตโนมัติแจ้งให้ลูกค้าทราบว่า กนอ. ได้รับข้อมูลจากลูกค้าเป็นที่เรียบร้อยแล้ว (ภายใน 5
                    นาทีหลังจากข้อความเข้าสู่ระบบ) <br />
                    2) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 24 ชั่วโมง (ในวันและเวลาทำการ) <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Office phone":
            text = (
                <Text>
                    มาตรฐานการให้บริการ
                    <br />
                    1) มีพนักงาน กนอ. รับสายทุกครั้งของเสียงเรียกเข้าหรือมีการโอนเข้าระบบตอบรับอัตโนมัติ (Interactive Voice Response : IVR)
                    และมีเมนูเลือกสำหรับให้โอนสายไปส่วนงานต่าง ๆ<br />
                    2) ระบบโทรศัพท์สำนักงานสามารถให้บริการได้ตามวันและเวลาทำการ
                    <br />
                    3) กรณีที่คำถามมีความซับซ้อน และไม่สามารถตอบคำถามได้ทันที พนักงาน กนอ. มีการแจ้งกลับทุกครั้ง ตามเวลาที่ระบุไว้กับลูกค้า
                </Text>
            );
            break;
        case "LinkIn":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard)
                    <br />
                    1) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 1 ชั่วโมง
                    <br />
                    2) ระบบสามารถให้บริการข้อมูลแก่ลูกค้าได้ทันทีที่ลูกค้าต้องการ (24 ชั่วโมง)
                    <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Wechat":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) กรณีติดต่อผ่านระบบ Chat จะพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 15 นาที <br />
                    2) ประชาสัมพันธ์หรือประกาศข้อมูลข่าวสารที่สำคัญ เช่น แจ้งประกาศปรับปรุงระบบ แจ้งหยุดบริการที่สำนักงานใหญ่ เป็นต้น
                    (กรณีเป็นประกาศสำคัญจะแจ้งล่วงหน้าอย่างน้อย 3 วัน) <br />
                    3) กรณีข่าวสารที่ประชาสัมพันธ์จำเป็นต้องเข้าสู่ระบบเว็บไซต์อื่น หรือทำการยังแอปพลิเคชันอื่น นอกจากการนำส่งด้วยภาพแล้ว
                    จะมีการนำส่งในรูปแบบข้อความ (Text) ที่ลูกค้าสามารถกด Link เพื่อเข้าใช้บริการทางช่องทางอื่นได้โดยทันที หรือมีภาพ QR Code ประกอบ
                    เพื่ออำนวยความสะดวกแก่ลูกค้า (ดำเนินการทุกครั้ง) <br />
                    4) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Weibo":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) มีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 1 ชั่วโมง <br />
                    2) ระบบสามารถให้บริการข้อมูลแก่ลูกค้าได้ทันทีที่ลูกค้าต้องการ (24 ชั่วโมง) <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้า รวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "One Stop Service Center":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard)
                    <br />
                    1) มีพนักงาน กนอ. กล่าวต้อนรับเมื่อมีลูกค้าเข้ามาใช้บริการ
                    <br />
                    2) มีการแจ้งประกาศวันและเวลาทำการที่ชัดเจน และกรณีมีเหตุให้ต้องปิดทำการ กนอ. จะแจ้งให้ลูกค้าทราบอย่างน้อย 3 วันทำการ
                    <br />
                    3) จัดให้มีพนักงาน กนอ. พร้อมให้บริการผลัดเปลี่ยนหมุนเวียนกันปฏิบัติงาน โดยไม่มีการหยุดพักในวันและเวลาทำการ และมีพนักงาน กนอ.
                    ให้บริการพร้อมประจำในจุดเคาน์เตอร์ให้บริการ ดังนี้ - มีพนักงาน กนอ. ให้บริการจำนวนไม่น้อยกว่าร้อยละ 70
                    ของจำนวนเคาน์เตอร์ในช่วงเวลาปกติ หรือมีลูกค้าเข้าใช้บริการไม่เกินร้อยละ 50- มีพนักงาน กนอ. ให้บริการจำนวนร้อยละ 100
                    ของจำนวนเคาน์เตอร์ในช่วงเวลาเร่งด่วน หรือมีลูกค้าเข้าใช้บริการมากกว่าหรือเท่ากับร้อยละ 50 ขึ้นไป
                    <br />
                    4) มีพนักงาน กนอ. ที่สามารถให้บริการแทนกันได้ในงานบริการเบ็ดเสร็จอย่างน้อย 3 ราย
                    <br />
                    5) จัดให้มีระบบคิวเพื่อให้บริการแก่ลูกค้าอย่างเป็นธรรม โดยมีระยะเวลารอไม่เกิน 15 นาที ต่อราย (กรณีที่มีลูกค้ารอนานกว่ามาตรฐานกำหนด
                    จะมีพนักงาน กนอ. เข้าไปพูดคุยเบื้องต้น เพื่อรับเรื่อง โดยมีอัตราการยอมรับเหตุฉุกเฉินได้ไม่เกิน 3 รายต่อวัน)
                    <br />
                    6) พนักงาน กนอ. ตอบคำถามพื้นฐานให้กับผู้รับบริการและแก้ไขปัญหาได้ และพนักงาน กนอ.
                    ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้ (เมื่อลูกค้าร้องขอ)
                    โดยจะดำเนินการทันทีหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าว ต้องมีการตรวจสอบหรือค้นหาข้อมูลก่อน และแจ้งให้ลูกค้าทราบ
                    <br />
                    7) มีการบันทึกข้อมูลของลูกค้าที่เข้ามาสอบถามทุกราย (เช่น ชื่อ-นามสกุล ความต้องการ/ความสนใจ เบอร์โทรศัพท์ Email LineID เป็นต้น)
                    <br />
                    8) เสนอช่องทางติดต่อกลับให้แก่ลูกค้าทุกราย (กรณีที่ลูกค้าอาจมีข้อสงสัย หรือต้องการสอบถามข้อมูลเพิ่มเติม)
                </Text>
            );
            break;
        case "Application I-EA-T Touch":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) ระบบสามารถใช้งานได้ตลอด 24 ชั่วโมง <br />
                    2) กรณีลูกค้าเกิดปัญหาในการใช้งาน หรือต้องการสอบถามข้อมูลเพิ่มเติม จะมีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 24 ชั่วโมง
                    (ในวันและเวลาทำการ) <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถเสนอแนวทางการแก้ไขปัญหาได้ (เมื่อลูกค้าร้องขอ)
                    (และภายหลังจากรับเรื่อง/หรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง จะมีการแจ้งให้ลูกค้าทราบ{" "}
                    <br />
                    4) กรณีที่มีการปรับปรุงระบบ กนอ. จะแจ้งให้ผู้รับบริการทราบล่วงหน้า อย่างน้อย 3 วัน ก่อนการปรับปรุงระบบ
                </Text>
            );
            break;
        case "I-EA-T e-PP":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) ระบบสามารถใช้งานได้ตลอด 24 ชั่วโมง <br />
                    2) กรณีลูกค้าเกิดปัญหาในการใช้งาน หรือต้องการสอบถามข้อมูลเพิ่มเติม จะมีพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 24 ชั่วโมง
                    (ในวันและเวลาทำการ) <br />
                    3) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถเสนอแนวทางการแก้ไขปัญหาได้ (เมื่อลูกค้าร้องขอ)
                    (และภายหลังจากรับเรื่อง/หรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง จะมีการแจ้งให้ลูกค้าทราบ{" "}
                    <br />
                    4) กรณีที่มีการปรับปรุงระบบ กนอ. จะแจ้งให้ผู้รับบริการทราบล่วงหน้า อย่างน้อย 3 วัน ก่อนการปรับปรุงระบบ
                    <br />
                    5) กรณีคำขอรับสิทธิประโยชน์ที่เกี่ยวกับภาษี (Tax Privileges) ต้องดำเนินการให้แล้วเสร็จภายใน 8 ชั่วโมง
                    <br />
                    6) กรณีคำขอรับสิทธิประโยชน์ที่ไม่เกี่ยวกับภาษี (Non-Tax Privileges) ต้องดำเนินการให้แล้วเสร็จภายใน 16 ชั่วโมง
                </Text>
            );
            break;
        case "Line Official":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) กรณีติดต่อผ่านระบบ Chat จะพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 15 นาที <br />
                    2) ประชาสัมพันธ์หรือประกาศข้อมูลข่าวสารที่สำคัญ เช่น แจ้งประกาศปรับปรุงระบบ แจ้งหยุดบริการที่สำนักงานใหญ่ เป็นต้น
                    (กรณีเป็นประกาศสำคัญจะแจ้งล่วงหน้าอย่างน้อย 3 วัน) <br />
                    3) กรณีข่าวสารที่ประชาสัมพันธ์จำเป็นต้องเข้าสู่ระบบเว็บไซต์อื่น หรือทำการยังแอปพลิเคชันอื่น นอกจากการนำส่งด้วยภาพแล้ว
                    จะมีการนำส่งในรูปแบบข้อความ (Text) ที่ลูกค้าสามารถกด Link เพื่อเข้าใช้บริการทางช่องทางอื่นได้โดยทันที หรือมีภาพ QR Code ประกอบ
                    เพื่ออำนวยความสะดวกแก่ลูกค้า (ดำเนินการทุกครั้ง) <br />
                    4) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Group Line":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard)
                    <br />
                    1) กรณีติดต่อผ่านระบบ Chat จะพนักงาน กนอ. ติดต่อกลับลูกค้าภายใน 15 นาที
                    <br />
                    2) ประชาสัมพันธ์หรือประกาศข้อมูลข่าวสารที่สำคัญ เช่น แจ้งประกาศปรับปรุงระบบ แจ้งหยุดบริการที่สำนักงานใหญ่ เป็นต้น
                    (กรณีเป็นประกาศสำคัญจะแจ้งล่วงหน้าอย่างน้อย 3 วัน)
                    <br />
                    3) กรณีข่าวสารที่ประชาสัมพันธ์จำเป็นต้องเข้าสู่ระบบเว็บไซต์อื่น หรือทำการยังแอปพลิเคชันอื่น นอกจากการนำส่งด้วยภาพแล้ว
                    จะมีการนำส่งในรูปแบบข้อความ (Text) ที่ลูกค้าสามารถกด Link เพื่อเข้าใช้บริการทางช่องทางอื่นได้โดยทันที หรือมีภาพ QR Code ประกอบ
                    เพื่ออำนวยความสะดวกแก่ลูกค้า (ดำเนินการทุกครั้ง)
                    <br />
                    4) พนักงาน กนอ. ต้องมีความรู้และพร้อมให้บริการแก่ลูกค้ารวมถึงสามารถนำเสนอแบบฟอร์มหรือเอกสารประกอบของพื้นที่ กนอ. ได้
                    (เมื่อลูกค้าร้องขอ) และภายหลังจากรับเรื่องหรือกรณีที่ข้อมูลดังกล่าวต้องได้รับการพิจารณาและส่งมอบจากส่วนงานอื่นที่เกี่ยวข้อง
                    จะมีการแจ้งให้ลูกค้าทราบ
                </Text>
            );
            break;
        case "Mail/Fax":
            text = (
                <Text>
                    มาตรฐานการให้บริการ (Service Standard) <br />
                    1) ประชาสัมพันธ์หรือประกาศข้อมูลข่าวสารที่สำคัญ เช่น แจ้งประกาศปรับปรุงระบบ แจ้งหยุดบริการที่ กนอ. สำนักงานใหญ่ เป็นต้น
                    (กรณีเป็นประกาศสำคัญควรแจ้งล่วงหน้าอย่างน้อย 3 วัน) <br />
                    2) การนำส่งเอกสารต้องระบุช่องทางการติดต่อกลับทุกครั้ง กรณีที่ลูกค้าอาจมีข้อสงสัย หรือต้องการสอบถามข้อมูลเพิ่มเติม
                </Text>
            );
            break;
        default:
            text = "-";
            break;
    }
    return text;
};

export const convertInst = (text) => {
    switch (text) {
        case "39754a17-6a8e-95d4-ba9c-82086244b353":
            text = "กองสื่อสารองค์กร";
            break;
        case "6787652e-0356-431f-c708-083102a1efe3":
            text = "กองลูกค้าสัมพันธ์";
            break;
        case "68ca70a4-e8e5-5b48-e961-d773901d439b":
            text = "กองการตลาด";
            break;
        case "c7aaea7e-b851-745d-d191-79e59388fa19":
            text = "กองอาคารและสถานที่";
            break;
        case "b36e6c6e-9ac8-9cd8-bf77-76ba1bf2bb84":
            text = "ฝ่ายบริหารผู้ประกอบการ";
            break;
        case "032b6473-4b60-ecc1-d97d-893e36a8e43b":
            text = "สำนักงานนิคมอุตสาหกรรม";
            break;
        default:
            text = "-";
            break;
    }
    return text;
};

export const convertInstToID = (text) => {
    switch (text) {
        case "กองสื่อสารองค์กร":
            text = "39754a17-6a8e-95d4-ba9c-82086244b353";
            break;
        case "กองลูกค้าสัมพันธ์":
            text = "6787652e-0356-431f-c708-083102a1efe3";
            break;
        case "กองการตลาด":
            text = "68ca70a4-e8e5-5b48-e961-d773901d439b";
            break;
        case "กองอาคารและสถานที่":
            text = "c7aaea7e-b851-745d-d191-79e59388fa19";
            break;
        case "ฝ่ายบริการผู้ประกอบการ":
            text = "b36e6c6e-9ac8-9cd8-bf77-76ba1bf2bb84";
            break;
        case "สำนักงานนิคมอุตสาหกรรม":
            text = "032b6473-4b60-ecc1-d97d-893e36a8e43b";
            break;
        default:
            text = "";
            break;
    }
    return text;
};

export const onDecimalChange = (value) => {
    if ((value && value <= 999999999999.99) || value == 0) {
        let fee = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

        return (Math.round(fee * 100) / 100).toFixed(2);
    } else {
        return false;
    }
};

export const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));

const Validation = {
    dataSourceMock: dataSourceMock,
    agency_All: agency_All,
    questionnaire: questionnaire,
    detailAgency: detailAgency,
    quarter: quarter,
    convertInst: convertInst,
    delay: delay,
    YearOf: YearOf,
    convertInstToID: convertInstToID,
    onDecimalChange: onDecimalChange,
    Years: Years,
    YearOfBC: YearOfBC,
};

export default Validation;
